<template>
  <div>
    <div v-if="!isBookmark" @click="createBookmark">
      <img src="/images/bookmark-icon.svg"/>
    </div>
    <div v-else @click="deleteBookmark">
      <img src="/images/bookmark-added-icon.svg"/>
    </div>
  </div>
</template>
<script>
import { restMethods } from '../mixins/rest_methods'
export default {
  data() {
    return {
      isBookmark: false
    }
  },
  props: {
    facilityId: {
      type: Number,
      default: null
    },
    facilityIsBookmark: {
      type: Boolean,
      default: false
    },
    isUnlogin: {
      type: Boolean,
      default: true
    },
  },
  mixins: [restMethods],
  created() {
    this.isBookmark = this.facilityIsBookmark;
  },
  methods: {
    async createBookmark(){
      try {
        if(this.isUnlogin) location.href = '/login'
        await this.postMethod(`/facilities/${this.facilityId}/create_bookmark`, {});
        this.isBookmark = true;
      }
      catch(e) {
        this.errorMessageText = e.response.data.messages.join();
        console.error("作成に失敗しました");
      }
    },
    async deleteBookmark(){
      try {
        await this.deleteMethod(`/facilities/${this.facilityId}/delete_bookmark`, {});
        this.isBookmark = false;
      }
      catch(e) {
        this.errorMessageText = e.response.data.messages.join();
        console.error("削除に失敗しました");
      }
    },
  },
}
</script>